// Removed vuebar-horizontal: not compatible with Vue 3
import { defineNuxtPlugin } from 'nuxt/app';
export default defineNuxtPlugin(() => {
  // No-op stub
});
